var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBa = function SvgIconBa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M12 0A11.99 11.99 0 0 0 1.877 5.552L18.15 22.305A11.99 11.99 0 0 0 24 11.999c0-6.627-5.373-12-12-12"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#0052B4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12c0-3.114-1.186-5.95-3.13-8.083v16.165A11.96 11.96 0 0 0 24 11.999M14.99 22.587h1.257l.388-1.197.389 1.196h.63q.58-.312 1.12-.682L2.095 5.224q-.412.602-.75 1.254l.148.456 1.257-.001-1.016.74.389 1.194-1.018-.738-.606.442A12 12 0 0 0 0 11.999c0 6.627 5.373 12 12 12 1.401 0 2.746-.24 3.996-.682zM2.677 11.477l.387-1.195-1.017-.739h1.257l.388-1.196.389 1.195h1.257l-1.017.739.39 1.195-1.018-.738zm2.588 2.61.388-1.197-1.017-.738h1.257l.387-1.196.39 1.195h1.256l-1.016.739.39 1.195-1.018-.738zm2.589 2.608.387-1.196-1.017-.738h1.257l.388-1.197.389 1.196 1.257-.001-1.016.74.389 1.194-1.018-.738zm3.605 1.87-1.017.738.388-1.195-1.017-.739h1.257l.387-1.196.39 1.195h1.257l-1.017.739.39 1.195zm1.572 3.347.388-1.195-1.018-.739h1.257l.388-1.196.39 1.195h1.256l-1.016.739.389 1.195-1.017-.738z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconBa;